<template>
  <div class="modal__comments">
    <Comment v-for="(comment, index) in comments" :comment="comment" :key="`comment-${index}`"></Comment>
    <CommentSkeleton v-for="(comment, index) in blankComments" :key="`blank-${index}`"></CommentSkeleton>
  </div>
</template>

<script>
  import lodash from 'lodash';
  import { mapGetters } from 'vuex';
  import Comment from './Comment.vue';
  import CommentSkeleton from './CommentSkeleton.vue';

  export default {
    name: 'CommentsDisplay',
    components: {
      Comment,
      CommentSkeleton,
    },
    props: ['comments'],
    computed: {
      ...mapGetters('meetingAgendas', ['loaders']),
      commentLoading() {
        return this.loaders.comment;
      },
      numBlankComments() {
        if (this.commentLoading) {
          return this.comments.length - 2 < 0 ? Math.abs(this.comments.length - 3) : 1;
        }
        return this.comments.length - 2 < 0 ? Math.abs(this.comments.length - 2) : 0;
      },
      blankComments() {
        return this.numBlankComments ? lodash.map(Array(this.numBlankComments), item => ({})) : [];
      },
    },
  };
</script>
